import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { serverLine } from "../../../controllers/network/serverLine";

const Input = styled.input`
  width: 100%;
  min-width: 220px;
  border: 1px solid var(--border);
  background: var(--surfaceSolid);
  color: var(--element);
  border-radius: 8px;
  font-size: 13px;
  padding: 8px 10px;
  outline: none;

  &:focus {
    border-color: var(--accent);
  }

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }
`;

export default function ObservationCell({
  value,
  date,
  userID,
  readOnly,
  onLocalChange,
}) {
  const [text, setText] = useState(value || "");
  const timerRef = useRef(null);
  const lastSavedRef = useRef(value || "");
  const isFocusedRef = useRef(false);

  useEffect(() => {
    if (isFocusedRef.current) return;
    setText(value || "");
    lastSavedRef.current = value || "";
  }, [value, date, userID]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  function scheduleSave(nextValue) {
    if (readOnly || !date || !userID) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      saveNow(nextValue);
    }, 700);
  }

  async function saveNow(nextValue) {
    if (readOnly || !date || !userID) return;
    if (lastSavedRef.current === nextValue) return;
    try {
      await serverLine.patch("/presence-observation", {
        date,
        userID,
        observation: nextValue,
      });
      lastSavedRef.current = nextValue;
    } catch (e) {
      console.log("Failed to save presence observation", e);
    }
  }

  return (
    <Input
      disabled={readOnly}
      value={text}
      placeholder="Observation"
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onFocus={() => {
        isFocusedRef.current = true;
      }}
      onChange={(e) => {
        const next = e.target.value;
        setText(next);
        onLocalChange?.(next);
        scheduleSave(next);
      }}
      onBlur={() => {
        isFocusedRef.current = false;
        if (timerRef.current) clearTimeout(timerRef.current);
        saveNow(text);
      }}
    />
  );
}
